import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { MaintainEquipmentListResponse, MaintainEquipmentQueryParams } from '@frontend/equipment/types';

export class EquipmentMaintainClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchMaintainEquipments(
        queryParams?: ApiQueryParams<MaintainEquipmentQueryParams>,
        withCredentials?: Token
    ): Promise<MaintainEquipmentListResponse> {
        return await this.apiPaginated<MaintainEquipmentListResponse, MaintainEquipmentQueryParams>(
            `${this.endpoint}/maintain-equipments`,
            queryParams,
            withCredentials
        );
    }

    public static async fetchMaintainEquipmentsBySpot(
        accountId: string,
        spotId: string,
        queryParams?: ApiQueryParams<MaintainEquipmentQueryParams>,
        withCredentials?: Token
    ): Promise<MaintainEquipmentListResponse> {
        return await this.apiPaginated<MaintainEquipmentListResponse, MaintainEquipmentQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/maintain-equipments`,
            queryParams,
            withCredentials
        );
    }
}
